import React from "react";
import { Glyphicon } from "react-bootstrap";

export default () => <Glyphicon glyph="refresh" className="spinning"/>



// WEBPACK FOOTER //
// ./src/components/LoaderIcon.js